import {
  Chip,
  ChipProps,
  FormControl,
  FormHelperText,
  Grid2 as Grid,
  Grid2Props,
  InputLabel,
  Stack,
  Typography,
  Tooltip,
  Zoom,
} from "@mui/material";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useFormHandlerContext } from "../../../../controllers/formController";
import { useNamePrefix } from "../../fields/subForms/NamePrefixContext";
import { singleGridItem } from "../../fields/defaultStyles";

interface StatusOption extends ChipProps {
  value: any;
}

interface ProofreadingStatusSelectionProps extends Grid2Props {
  name: string;
  label: string;
  options: StatusOption[];
  disabled?: boolean;
}

const FormStatusSelectionField: React.FC<ProofreadingStatusSelectionProps> = ({
  name,
  label,
  disabled = false,
  options,
  ...grid
}) => {
  const { isProcessing } = useFormHandlerContext();
  const { control } = useFormContext();
  const parentPrefix = useNamePrefix();
  const fullName = parentPrefix ? `${parentPrefix}.${name}` : name;

  const selectedIndicator = (show: boolean) => (
    <Zoom in={show}>
      <Typography p={1} fontWeight="bold" fontSize="2em">
        •
      </Typography>
    </Zoom>
  );

  return (
    <Grid {...singleGridItem} {...grid}>
      <Controller
        name={fullName}
        control={control}
        render={({ field, fieldState }) => (
          <>
            <InputLabel required id={`${fullName}-label`} sx={{ mb: 1 }}>
              {label}
            </InputLabel>
            <FormControl fullWidth error={!!fieldState.error}>
              <Stack direction="row" flexWrap="wrap" gap={1}>
                {options.map((status, index) => {
                  const isSelected = field.value === status.value;

                  return (
                    <Tooltip key={index} title={status.label}>
                      <Chip
                        key={index}
                        icon={selectedIndicator(isSelected)}
                        label={
                          <Stack direction="row" alignItems="center" gap={1}>
                            {status.label}
                            {status.icon}
                          </Stack>
                        }
                        variant="filled"
                        color={status.color}
                        size="medium"
                        onClick={() => field.onChange(status.value)}
                        disabled={disabled || isProcessing}
                        clickable
                        className={isSelected ? "chip-selected" : ""}
                      />
                    </Tooltip>
                  );
                })}
              </Stack>
              {fieldState.error && (
                <FormHelperText>{fieldState.error?.message}</FormHelperText>
              )}
            </FormControl>
          </>
        )}
      />
    </Grid>
  );
};

export default FormStatusSelectionField;
